'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _call2 = require('./_internal/_call');

var _call3 = _interopRequireDefault(_call2);

var _concat2 = require('./_internal/_concat');

var _concat3 = _interopRequireDefault(_concat2);

var _len2 = require('./_internal/_len');

var _len3 = _interopRequireDefault(_len2);

var _lt2 = require('./_internal/_lt');

var _lt3 = _interopRequireDefault(_lt2);

var _or2 = require('./_internal/_or');

var _or3 = _interopRequireDefault(_or2);

var _reverse2 = require('./_internal/_reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _spread = require('./spread');

var _spread2 = _interopRequireDefault(_spread);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Take a function and return a function which accepts args in reverse order
 *
 * @module reverse
 * @func
 * @since 1.1.0
 * @param {function} fn
 * @return {function}
 * @example
 *
 *     const foo = (a, b, c) => a + b - c;
 *     reverse(foo); //=> (c)(b)(a) => c + b - a;
 */

var reverse = function reverse(fn, len) {
    var length = (0, _or3.default)(len, (0, _len3.default)(fn));
    var internal = (0, _compose2.default)(function (args) {
        return (0, _lt3.default)((0, _len3.default)(args), length) ? (0, _compose2.default)(function (ops) {
            return (0, _call3.default)(internal, (0, _concat3.default)(args, ops));
        }, _spread2.default) : (0, _call3.default)(fn, (0, _reverse3.default)(args));
    }, _spread2.default);

    return internal;
};

exports.default = reverse;